import React, { useCallback, useState } from "react";
import styled from "styled-components";
import { BiLogoGoogle } from "react-icons/bi";
import {
  signInWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import { auth } from "../../firebase";
import {
  getFirestore,
  collection,
  doc,
  setDoc,
  getDoc,
} from "firebase/firestore";
import { Helmet } from "react-helmet";
import { CustomLink } from "../../components/buttons/Button.styled";
import { useNavigate } from "react-router-dom";

const db = getFirestore();

function LoginCom() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      if (!email || !password) return;

      try {
        await signInWithEmailAndPassword(auth, email, password);
        const userRef = doc(db, "users", auth.currentUser.uid);
        const userSnap = await getDoc(userRef);
        const role = userSnap.data()?.userData?.accountType;

        navigate("/giris-sonrasi");
      } catch {
        alert("Kullanıcı bulunamadı.");
      }
    },
    [email, password, navigate]
  );

  const handleGoogleSignup = async () => {
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      const { displayName, email, uid } = result.user;
      const userDocRef = doc(collection(db, "users"), uid);
      const userDoc = await getDoc(userDocRef);

      if (!userDoc.exists()) {
        await setDoc(userDocRef, {
          uid,
          totalPoint: 0,
          userData: {
            displayName,
            email,
            selfIntroduction: "Burası senin alanın...",
            class: "",
            city: "",
            district: "",
            school: "",
            birthDate: "",
            accountType: "öğrenci",
            defaultAccountType: "öğrenci",
            createdAt: new Date().toISOString(),
            avatar: "1",
          },
        });
      } else {
        const role = userDoc.data()?.userData?.accountType;
        navigate("/giris-sonrasi");
      }
    } catch {
      alert("Google ile giriş yapılamadı.");
    }
  };

  return (
    <Container>
      <Helmet>
        <title>Giriş Sayfası</title>
      </Helmet>
      <LeftContainer>
        <MainBox style={{ color: "#fff" }}>
          <h1>Giriş Yap</h1>
          <h3>Seni yeniden görmek güzel!</h3>
          <h4>Giriş yapmak için dilediğiniz seçeneği seçebilirsiniz.</h4>
        </MainBox>
      </LeftContainer>
      <RightContainer>
        <MainBox>
          <h2>Giriş Yap</h2>
          <SocialButtons>
            <Socials onClick={handleGoogleSignup}>
              <BiLogoGoogle
                className="socialButtons"
                style={{ color: "#DB4437" }}
              />
              <div>Google İle Giriş Yap</div>
            </Socials>
          </SocialButtons>
          <EmailForm onSubmit={handleSubmit}>
            <label>Email İle Giriş Yap</label>
            <Input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)}
            />
            <Input
              type="password"
              placeholder="Parola"
              value={password}
              onChange={(e) => setPassword(e.currentTarget.value)}
            />
            <button type="submit">Giriş Yap</button>
            <CustomLink to="/parolami-unuttum">
              Parolanızı mı unuttunuz?
            </CustomLink>
          </EmailForm>
        </MainBox>
      </RightContainer>
    </Container>
  );
}

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: calc(100vh - 100px);
  min-height: 500px;
  max-width: var(--main-width);
`;

export const LeftContainer = styled.div`
  width: 50%;
  height: 100%;
  background-color: var(--main-color);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const RightContainer = styled.div`
  width: 50%;
  height: 100%;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
  @media (max-width: 768px) {
    width: 100%;
    background-color: var(--main-color);
    padding: 0 2rem;
  }
`;

export const MainBox = styled.div`
  width: 450px;
  h1,
  h3 {
    font-family: "Poetsen One", sans-serif;
    margin-bottom: 2rem;
  }
  h4 {
    padding-top: 2rem;
  }
  h2 {
    font-family: "Poetsen One", sans-serif;
    text-align: center;
    color: #fff;
    @media (min-width: 768px) {
      display: none;
    }
  }
  @media (max-width: 768px) {
    border: 1px solid var(--main-color);
    padding: 0.5em;
    border-radius: 15px;
  }
`;

export const SocialButtons = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  height: 100px;
`;

export const Socials = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--main-color);
  border-radius: 5px;
  cursor: pointer;
  padding: 3px 10px;
  width: 100%;
`;

export const EmailForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  label {
    @media (max-width: 768px) {
      color: #fff;
    }
  }
  button {
    width: 100%;
    height: 40px;
    background-color: var(--main-color);
    border: 1px solid var(--main-color);
    border-radius: 5px;
    color: #fff;
    cursor: pointer;
    &:hover {
      background-color: #fff;
      color: var(--main-color);
    }
  }
`;

export const Input = styled.input`
  width: 100%;
  height: 40px;
  border: 1px solid var(--main-color);
  border-radius: 5px;
  padding: 0 10px;
  box-sizing: border-box;
`;

export default LoginCom;
